import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M19 7.5c0 1.56 1.02 2.88 2.43 3.333a9.602 9.602 0 0 1 0 2.334 3.501 3.501 0 0 0-2.082 4.855 9.554 9.554 0 0 1-1.326 1.326 3.501 3.501 0 0 0-4.856 2.081 9.582 9.582 0 0 1-2.333 0 3.502 3.502 0 0 0-4.855-2.081 9.555 9.555 0 0 1-1.276-1.266 3.501 3.501 0 0 0-2.108-4.74 9.583 9.583 0 0 1-.023-2.509 3.502 3.502 0 0 0 2.081-4.855 9.557 9.557 0 0 1 1.326-1.326 3.502 3.502 0 0 0 4.855-2.082 9.594 9.594 0 0 1 2.334 0 3.501 3.501 0 0 0 4.855 2.082c.484.398.928.842 1.326 1.326-.223.46-.348.976-.348 1.522Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "3.5"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }